import React, { useEffect } from 'react';
import { Layout, Typography, Dropdown, Menu, Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import useTemplateGlobalState from '../../atoms/variables';
import User from './components/UserComponent';

import { useLocation } from 'react-router-dom';

import './style.css';
import Breadcrumbs from './components/Breadcrumbs';
import FAQButton from '../../../VirtualEnginner/components/VirtualEngineerButtons/components/FAQ';

const { Header } = Layout;
const { Title } = Typography;

const HeaderComponent = () => {
  const { title, buttons, customMenu } = useTemplateGlobalState();
  const location = useLocation();

  const isMobile = window.screen.width < 980;

  useEffect(() => {
    console.log(buttons);
  }, [buttons]);

  return (
    <Header
      id='header'
      style={
        location.pathname.match(/\/assets\/[\dA-z]+/) ||
        location.pathname.match(/\/positions\/[\dA-z]+/) ||
        location.pathname.match(/\/instruments\/[\dA-z]+/) ||
        location.pathname.match(/\/organizations\/[\dA-z]+/) ||
        location.pathname.match(/\/departments\/[\dA-z]+/) ||
        location.pathname.match(/\/cost-centers\/[\dA-z]+/) ||
        location.pathname.match(/\/inventory\/[\dA-z]+/) ||
        location.pathname.match(/\/interconnections\/[\dA-z]+/) ||
        location.pathname.match(/\/user-groups\/[\dA-z]+/) ||
        location.pathname.match(/\/users\/[\dA-z]+/)
          ? { borderBottom: 'none' }
          : {}
      }
      className={customMenu ? 'has-menu' : 'no-menu'}
    >
      <div className='header-content'>
        <div className='title'>
          {typeof title === 'string' ? <Title className='productName'>{title}</Title> : title}
          <div className='breadcrumbs'>
            <Breadcrumbs />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          {!location.pathname.includes('/virtual-engineer') ? (
            <FAQButton navigateLink='/faq' />
          ) : (
            <FAQButton />
          )}
          {isMobile ? (
            buttons?.filter((btn) => btn.id !== 'FAQButton')?.length > 0 && (
              <Dropdown
                overlay={
                  <Menu>
                    {buttons
                      ?.filter((btn) => btn.id !== 'FAQButton')
                      ?.map((btn, idx) => {
                        if (!btn.node) return;
                        return <Menu.Item key={`btn-${idx}`}>{btn.node}</Menu.Item>;
                      }) || []}
                  </Menu>
                }
                trigger={['click']}
                placement='bottomRight'
              >
                <Button type='text' icon={<MenuOutlined style={{ fontSize: '20px' }} />} />
              </Dropdown>
            )
          ) : (
            <div className='header-buttons'>
              {buttons?.map((button, index) => (
                <React.Fragment key={`btn-${index}`}>
                  {button?.node}
                  <div className='header-buttons-divider'></div>
                </React.Fragment>
              ))}
            </div>
          )}
          <User />
        </div>
      </div>
      {customMenu}
    </Header>
  );
};

export default HeaderComponent;
